/**
 * Pure helpers used by the Customer Form and its tabs.
 */

/**
 * Converts an arbitrary error payload (string, array of Pydantic errors,
 * axios response body, nested object with `detail` / `msg`) into a single
 * human-readable string suitable for toast notifications.
 */
export const formatErrorMessage = (error) => {
  if (typeof error === 'string') {
    return error;
  }

  // Pydantic validation errors — array of { loc, msg }
  if (Array.isArray(error)) {
    return error
      .map((err) => {
        const field = err.loc ? err.loc.join('.') : 'field';
        return `${field}: ${err.msg}`;
      })
      .join(', ');
  }

  if (error && typeof error === 'object') {
    if (error.detail) return formatErrorMessage(error.detail);
    if (error.msg) return error.msg;
    return JSON.stringify(error);
  }

  return 'An error occurred';
};
